import React from "react";

import AuthenticationCard from "../../../components/Authentication/AuthenticationCard";

import { ArchiveBoxXMarkIcon } from "@heroicons/react/24/outline";

// Keeping track of menu expansion
import { useDispatch } from "react-redux";

// Handling user logout
import { logoutUser } from "../../../redux/features/userState/userStateSlice";
import { resetApplication } from "../../../redux/features/applicationState/applicationStateSlice";
import { resetPatient } from "../../../redux/features/patientState/patientStateSlice";

import toastManager from "../../../helpers/toastManager";

const ResetStateScreen = () => {
  const dispatch = useDispatch();

  const fullyResetState = () => {
    dispatch(resetApplication());
    dispatch(logoutUser());
    dispatch(resetPatient());

    toastManager(
      "success",
      "State Reset Successfully!",
      "All settings, and parameters have been reset to their defaults."
    );
  };

  return (
    <AuthenticationCard
      AuthenticationPromptTitle="Clinical Dashboard State Reset"
      AuthenticationPromptText="Fully reset the Clinical Dashboard interface to default parameters."
    >
      <div className="flex flex-col items-center justify-center w-full sm:w-4/5 py-6 space-y-10">
        <button
          className={`flex items-center justify-center w-full py-4 space-x-3 select-none
                      rounded-md border border-neutral-300 bg-emerald-100
                      hover:bg-opacity-80 active:bg-emerald-200
                      `}
          onClick={fullyResetState}
        >
          <ArchiveBoxXMarkIcon className="h-10 w-10 text-neutral-700" />
          <p className="font-medium text-neutral-700 text-4xl">Reset State</p>
        </button>
      </div>
    </AuthenticationCard>
  );
};

export default ResetStateScreen;
